import React, { useEffect, useState, useMemo, useCallback } from "react";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import './styles.css'
import moment from 'moment'
import { Calendar, Views, DateLocalizer, momentLocalizer } from 'react-big-calendar'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { employeeAttendanceListRequest, employeeListRequest } from '../../../redux/employee/employee.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { APP_CONSTANTS } from "../../../utils/AppConstants";

const AttendanceList = props => {
    const { state } = useLocation()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { attendanceListSuccess, attendanceListError,
        employeeListSuccess, employeeListError
    } = useSelector((state) => state.employee)
    const localizer = momentLocalizer(moment)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const [eventList, setEventList] = useState([])
    const [selectedTab, setSelectedTab] = useState(0)
    const TAB_ITEMS = {
        MY_ATTENDANCE: 'MY ATTENDANCE',
        MY_TEAM: 'MY TEAM'
    }
    const [showCalendarView, setShowCalendarView] = useState(true)
    const [showEmployeeList, setShowEmployeeList] = useState(true)
    const [selectedEmployee, setSelectedEmployee] = useState(null)

    useEffect(() => {
        fetchAttendanceList(getFirstDay(), getLastDay())
    }, [])

    const fetchAttendanceList = (startDate, endDate, employeeId = null) => {
        const data = {}
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        } else {
            if (!isNull(state) && !isEmpty(state.businessId) && !isEmpty(state.locationId)) {
                data.businessId = state.businessId
                data.locationId = state.locationId
            }
        }
        console.log('employeeId', employeeId);

        if (isEmpty(employeeId)) {
            if (!isNull(state) && !isNull(state.employeeAttendanceList) && state.employeeAttendanceList === true) {
                data.employeeId = state.employeeId
            } else {
                if (isLoggedInUserBusiness(user)) {
                    displayErrorToast('Only employees attendance can be viewed. Try login with employee account')
                    return
                }
                data.employeeId = user.data.userDetails.employeeId
            }
        } else {
            data.employeeId = employeeId
        }
        data.startDate = startDate
        data.endDate = endDate
        setLoading(true)
        dispatch(employeeAttendanceListRequest(data))
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {
            supervisorId: user.data.userDetails.employeeId,
            supervisorType: user.data.userDetails.userType
        }
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        dispatch(employeeListRequest(data))
    }

    const getFirstDay = (date = null) => {
        let tempDate = date ? date : new Date();
        let firstDay = new Date(tempDate.getFullYear(), tempDate.getMonth(), 1);
        return moment(firstDay).format('YYYY-MM-DD').toString()
    }

    const getLastDay = (date = null) => {
        let tempDate = date ? date : new Date();
        var lastDay = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0);
        return moment(lastDay).format('YYYY-MM-DD').toString()
    }

    useEffect(() => {
        if (!isNull(attendanceListSuccess)) {
            setLoading(false)
            if (!isEmpty(attendanceListSuccess.data)) {
                let eventListArr = []
                attendanceListSuccess.data.forEach(element => {
                    eventListArr.push({
                        title: 'Present',
                        start: moment(element.startTime).utc().toDate(),
                        end: moment(element.endTime).utc().toDate()
                    })
                });
                setEventList(eventListArr)
            }
        } else if (!isNull(attendanceListError)) {
            setLoading(false)
            setEventList([])
        }
    }, [attendanceListSuccess, attendanceListError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    const ColoredDateCellWrapper = ({ children }) =>
        React.cloneElement(React.Children.only(children), {
            style: {
                backgroundColor: 'lightblue',
            },
        })

    const { components, defaultDate, max, views } = useMemo(
        () => ({
            components: {
                timeSlotWrapper: ColoredDateCellWrapper,
            },
            defaultDate: new Date(),
            views: Object.keys(Views).map((k) => Views[k]),
        }),
        []
    )

    const onNavigate = useCallback((newDate) => {
        let employeeId = selectedEmployee?.employeeId
        fetchAttendanceList(getFirstDay(newDate), getLastDay(newDate), employeeId)
    })

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.MY_ATTENDANCE) {
            setSelectedTab(0)
            setShowCalendarView(true)
            setShowEmployeeList(false)
            setSelectedEmployee(null)
            fetchAttendanceList(getFirstDay(), getLastDay())
        } else {
            setSelectedTab(1)
            setShowCalendarView(false)
            setShowEmployeeList(true)
            setSelectedEmployee(null)
            fetchEmployeeList()
        }
    }

    const handleViewEmployeeAttendanceClick = (item) => {
        setSelectedEmployee(item)
        setShowEmployeeList(false)
        setShowCalendarView(true)
        fetchAttendanceList(getFirstDay(), getLastDay(), item.employeeId)
    }

    const handleBackClick = () => {
        setShowCalendarView(false)
        setShowEmployeeList(true)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Attendance' />
                {isLoggedInUserEmployee(user) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.MY_ATTENDANCE) }}>{TAB_ITEMS.MY_ATTENDANCE}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.MY_TEAM) }}>{TAB_ITEMS.MY_TEAM}</div>
                </div>}
                {showCalendarView === true && showEmployeeList === false && selectedTab === 1 && <div className="al-back-row-container"
                    onClick={() => { handleBackClick() }}>
                    <div className="al-back-icon-container">
                        <img src={require('../../../assets/ic_back_icon.png')} className="img" />
                    </div>
                    <div className="al-back-label">View Team Members</div>
                </div>}
                {(showCalendarView === true || selectedTab === 0) && <div className="height600">
                    <Calendar
                        components={components}
                        localizer={localizer}
                        defaultDate={defaultDate}
                        step={60}
                        views={['month', 'day']}
                        style={{ height: 550 }}
                        onNavigate={onNavigate}
                        events={eventList}
                    />
                </div>}
                {(selectedTab === 1 || (showEmployeeList === true && showCalendarView === false)) && !isNull(employeeListSuccess) && !isEmpty(employeeListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employee Code</th>
                                <th scope="col" className="text-center">Personal Email</th>
                                <th scope="col" className="text-center">Mobile</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.firstName} {element.lastName}</td>
                                    <td className="text-center">{element.employeeCode}</td>
                                    <td className="text-center">{element.personalEmail}</td>
                                    <td className="text-center">+{element.mobile}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewEmployeeAttendanceClick(element) }}><div className="tr-action-btn">View Attendance</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {(selectedTab === 1 || (showEmployeeList === true && showCalendarView === false)) && !isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AttendanceList